import type { ReactNode } from 'react';

/** Props do layout das telas públicas de auth. */
export interface AuthPageLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}

/** Coluna centralizada com título, usada por login e telas de senha. */
export function AuthPageLayout({ title, description, children }: AuthPageLayoutProps): ReactNode {
  return (
    <main className="mx-auto flex min-h-screen max-w-sm flex-col justify-center gap-6 p-6">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {description !== undefined && <p className="text-muted-foreground">{description}</p>}
      </div>
      {children}
    </main>
  );
}
